import { NgModule } from "@angular/core";

import { CodeEditorModule } from "@acrodata/code-editor";

import { TextEditorsCoreModule } from "../text-editors-core.module";
import { JsonEditorComponent } from "./components/json-editor.component";
import { JsonEditorLanguageService } from "./services/json-editor-language.service";


@NgModule({
    declarations: [
        JsonEditorComponent
    ],
    providers: [
        JsonEditorLanguageService,
    ],
    exports: [
        JsonEditorComponent,
    ],
    imports: [
        TextEditorsCoreModule,
        CodeEditorModule,
    ]
})
export class JsonEditorModule {
}